import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useInvalidateSchedules } from "./useInvalidateSchedules";

/**
 * Refetches what a dedicated desk release changes: the desk's releases, the
 * resource lists that carry the release and the visible assignments, the
 * access rules the release created, and the reservations it cancelled.
 *
 * A release cancels the owner's bookings on the days it covers, and a
 * withdrawal cancels everyone else's, so everything that renders reservations
 * goes too: without that the agenda and the map keep showing bookings the
 * server has already dropped.
 */
export const useInvalidateDedicatedExceptions = () => {
  const queryClient = useQueryClient();
  const invalidateSchedules = useInvalidateSchedules();

  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: ["resources.dedicatedExceptions"]
      }),
      queryClient.invalidateQueries({
        queryKey: ["users.dedicatedExceptions"]
      }),
      queryClient.invalidateQueries({
        queryKey: ["organizations.resourcesAll"]
      }),
      queryClient.invalidateQueries({ queryKey: ["resource"] }),
      queryClient.invalidateQueries({
        queryKey: ["organizations.resourceScheduledPermissionsAll"]
      }),
      invalidateSchedules()
    ]);
  }, [queryClient, invalidateSchedules]);
};
